/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  This DropZone component used to upload the file through button click and drag and drop method.
  acceptfile  : acceptfile props used to fiter the specified file which we have to upload the file.
  
*/

import './DropZone.css'
import React, { useState, useEffect, useMemo } from 'react' //useCallback, createRef, useState
import { useDropzone } from 'react-dropzone'
import DownloadIcon from '@mui/icons-material/SaveAltSharp'
import CloseIcon from '@mui/icons-material/Close'
import { useSetRecoilState, useRecoilState } from 'recoil' //, useRecoilValue
import { toastMessage, imageData } from '../../recoil/atoms/atoms'
import DocxIcon from '../../../../assets/images/DocxIcon.svg'
import Button from '../button/Button'

const DropZoneNew = ({
  showDefault = 'true',
  baseStyleApply = true,
  ...props
}) => {
  const {
    updateFiles,
    innerContent,
    btnContent,
    customDropZoneContent,
    customDropZoneAppendContent,
    compHeight,
    icon,
    // flexDirection,
    allowedFormate,
    previewViewer,
    dropZoneErrorMessage,
    imageSrc,
    imageFileName,
    resetImageSrc,
    maxFilesCount,
    fromForm,
    maxSize,
    formMode,
    acceptContent,
    defaultIcon,
    logoErrorMessage,
    returnedDropZoneErrorMessage,
    returnMessageFun,
    downloadHandler,
    fileNameLocation,
    imageSizeContent,
    customDropZoneContentSubFunctionality,
    disableDownload = false,
  } = props
  const showToastMessage = useSetRecoilState(toastMessage)
  //const setShowLoading = useSetRecoilState(showLoading) imageSrc !== '' ? true :
  // const globalImage = useRecoilValue(imageData)
  // const setImageRecoil = useSetRecoilState(imageData)
  const [globalImage, setImageRecoil] = useRecoilState(imageData)
  const fromFormNames = ['organisationsetup', 'templatesetup', 'brandingsetup']

  const [isMultiFileErrorShow, setIsMultiFileErrorShow] = useState(true)

  const [files, setFiles] = useState([])
  const [filesCount, setFilesCount] = useState(imageSrc?.length > 0 ? 1 : 0)
  const [, setFilesEditMode] = useState(imageSrc)

  const multiFileErrorMessage = logoErrorMessage
    ? logoErrorMessage
    : 'To upload a new logo, remove the current one.'

  if (fromFormNames.includes(fromForm?.toLowerCase())) {
    /* istanbul ignore next */
    if (imageSrc?.length === 1 && filesCount === 0) {
      setFilesCount(1)
    }
  }

  // Here use direct color codes due to passed as params.
  const baseStyle = baseStyleApply
    ? {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // padding: '0px 20px 20px 20px',
        borderWidth: 2,
        borderRadius: 5,
        borderColor: '#C4C4C4',
        borderStyle: 'dashed',
        backgroundColor: '#f5f5f5',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out',
        height: compHeight || '100%',
      }
    : {}

  const focusedStyle = {
    borderColor: '#2196f3',
  }

  const acceptStyle = {
    borderColor: '#00e676',
  }

  const rejectStyle = {
    borderColor: '#ff1744',
  }

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    open,
    fileRejections,
  } = useDropzone({
    accept: allowedFormate || {
      'image/jpeg': ['.jpeg'],
      'image/jpg': ['.jpg'],
      'image/png': ['.png'],
      'image/heic': ['.heic'],
      'image/HEIC': ['.HEIC'],
      'image/bmp': ['.bmp', '.BMP'],
      'image/tiff': ['.tiff'],
      'image/TIFF': ['.TIFF'],
      'application/pdf': ['.pdf'],
      'image/tif': ['.tif'],
      'image/TIF': ['.TIF'],
    },
    maxSize: maxSize,
    noClick: true,
    maxFiles: maxFilesCount,
    onDrop: (acceptedFiles) => {
      filesCount < 1
        ? setFiles(
            /* istanbul ignore next */
            acceptedFiles?.map((file) =>
              /* istanbul ignore next */
              Object.assign(file, {
                /* istanbul ignore next */
                preview: URL.createObjectURL(file),
              })
            )
          )
        : null

      setFilesCount(filesCount + 1)
      if (fromFormNames.includes(fromForm?.toLowerCase())) {
        /* istanbul ignore next */
        setImageRecoil(true)
      }
    },
  })
  useEffect(() => {
    if (updateFiles && acceptedFiles.length > 0) {
      /* istanbul ignore next */
      updateFiles(acceptedFiles, fileNameLocation)
    }
  }, [acceptedFiles])

  useMemo(() => {
    /* istanbul ignore next */
    if (fileRejections?.length > 0) {
      if (fromFormNames.includes(fromForm?.toLowerCase())) {
        if (fileRejections?.length > 1) {
          const erMessage = returnedDropZoneErrorMessage
            ? returnedDropZoneErrorMessage
            : 'Too many files selected. One logo can be added per organisation.'
          if (returnMessageFun) {
            returnMessageFun(erMessage)
          } else {
            showToastMessage({
              message: erMessage,
              status: 'error',
            })
          }
          if (fromFormNames.includes(fromForm?.toLowerCase())) {
            if (imageSrc?.length === 0 && files?.length === 1) {
              setImageRecoil(true)
              setFilesCount(files.length + 1)
            } else if (files?.length === 0 && imageSrc?.length === 1) {
              setImageRecoil(true)
            } else if (files?.length === 0 && imageSrc?.length === 0) {
              setFilesCount(0)
              setImageRecoil(false)
            }
          }
          // return true
        }

        if (
          (fileRejections?.length === 1 &&
            fileRejections[0]?.errors[0]?.code === 'file-too-large') ||
          fileRejections[0]?.errors[0]?.code === 'file-invalid-type'
        ) {
          const fileError = fileRejections[0]?.errors[0]?.code
          if (fileError === 'file-too-large') {
            if (returnMessageFun) {
              returnMessageFun(
                'Error! File size too big, maximum allowed is 10mb'
              )
            } else {
              showToastMessage({
                message: 'Error! File size too big, maximum allowed is 10mb',
                status: 'error',
              })
            }
          } else if (fileError === 'file-invalid-type') {
            if (returnMessageFun) {
              returnMessageFun(dropZoneErrorMessage)
            } else {
              showToastMessage({
                message: { dropZoneErrorMessage },
                status: 'error',
              })
            }
          }

          if (fromFormNames.includes(fromForm?.toLowerCase())) {
            if (imageSrc?.length === 0 && files?.length === 1) {
              setImageRecoil(true)
              setFilesCount(files.length + 1)
            } else if (files?.length === 0 && imageSrc?.length === 1) {
              setImageRecoil(true)
            } else if (files?.length === 0 && imageSrc?.length === 0) {
              setFilesCount(0)
              setImageRecoil(false)
            }
          }
        }
      } else {
        const errMessage =
          { dropZoneErrorMessage } ||
          'Error! File type is not permitted, please attach a document of the following type(s) only .png, .pdf, .jpg, .jpeg, .bmp, .tif, .tiff, .heic'
        if (returnMessageFun) {
          returnMessageFun(errMessage)
        } else {
          showToastMessage({
            message: errMessage,
            status: 'error',
          })
        }
        setFilesCount(0)
      }
    }
  }, [fileRejections])

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  )
  /* istanbul ignore next */
  const removeFile = (file) => () => {
    if (fromFormNames.includes(fromForm?.toLowerCase())) {
      setImageRecoil(false)
    }
    const newFiles = [...files]
    newFiles.splice(newFiles.indexOf(file), 1)
    setFiles(newFiles)
    setFilesCount(0)
    setFilesEditMode([])
    resetImageSrc()
  }

  useMemo(() => {
    if (
      fromFormNames.includes(fromForm?.toLowerCase()) &&
      globalImage === false &&
      formMode === 'new'
    ) {
      /* istanbul ignore next */
      setFiles([])
      /* istanbul ignore next */
      setFilesCount(0)
    }
  }, [globalImage])
  /* istanbul ignore next */
  const moreFileErrorMessage = () => {
    if (previewViewer && filesCount + 1 > 1 && returnMessageFun) {
      returnMessageFun(multiFileErrorMessage)
      setIsMultiFileErrorShow(false)
    }
    setFilesCount(filesCount + 1)
  }

  return (
    <div className="container dropzonearea">
      <div {...getRootProps({ style })}>
        <input
          className="fileupload"
          data-testid="drop-zone"
          {...getInputProps()}
        />
        <div className="dropDown_styles">
          {icon ? (
            <div className="dropDown_styles_Icon">
              <img className="Upload_logo" src={icon} onClick={open} />
            </div>
          ) : null}
          {innerContent || showDefault ? (
            <div className="dropDown_styles_DropFiles">
              <p className="fileuploadparas">
                {innerContent
                  ? innerContent
                  : showDefault === 'true'
                  ? 'Drop files here or'
                  : null}
              </p>
            </div>
          ) : null}
          {btnContent ? (
            <div>
              {filesCount === 0 && imageSrc?.length === 0 ? (
                <div className="custom_fileuploadbutton" onClick={open}>
                  {btnContent}
                </div>
              ) : (
                <div
                  className="custom_fileuploadbutton"
                  onClick={moreFileErrorMessage}
                >
                  {btnContent}
                </div>
              )}
            </div>
          ) : showDefault === 'true' ? (
            <button type="button" className="fileuploadbutton" onClick={open}>
              Select Files
            </button>
          ) : null}
          {customDropZoneContent || customDropZoneContentSubFunctionality ? (
            <div className="custom_fileuploadbutton">
              <div className=" dropZoneContent" onClick={open}>
                {customDropZoneContent}
              </div>
              <div className="dropZoneContentSubFunctionality">
                {customDropZoneContentSubFunctionality}
              </div>
            </div>
          ) : null}
          {customDropZoneAppendContent ? customDropZoneAppendContent : null}
        </div>
      </div>
      <div className="customContent">
        <div className="filetypeheading">
          <span>
            {acceptContent
              ? acceptContent
              : 'Accepted image types: JPEG, PNG or SVG | Max. file size: 10 MB | Resolution 72ppi'}
          </span>
          <span>{imageSizeContent ? imageSizeContent : null}</span>
        </div>
      </div>
      {previewViewer && files?.length > 0 ? (
        <div className="LogoContainer">
          {files?.map((file) => (
            <div className="LogoViewer" key={file?.name}>
              <div className="CancelLogo">
                {/*className="Logo_CancelIcon"*/}
                <CloseIcon onClick={removeFile(file)} />
              </div>
              <div className="Logo_OrgFileName">
                <div className="OrgLogo">
                  <img
                    src={defaultIcon ? DocxIcon : file?.preview}
                    className="imgClass"
                    alt={file?.name}
                  />
                </div>
                <div className="Logo_FileName" title={file?.name}>
                  {file?.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : null}
      {(globalImage || fromForm === 'templatesetup') &&
      previewViewer &&
      imageSrc?.length > 0 &&
      imageData ? (
        <div className="LogoContainer">
          <div className="LogoViewer" key={imageFileName}>
            <div className="CancelLogo">
              {/* className="Logo_CancelIcon" */}
              <CloseIcon onClick={removeFile(imageSrc)} />
            </div>
            <div className="Logo_OrgFileName">
              <div className="OrgLogo">
                <img
                  className={
                    fromForm === 'templatesetup' ? 'imgEditClass' : 'imgClass'
                  }
                  src={defaultIcon ? DocxIcon : imageSrc}
                  alt={imageFileName}
                />
              </div>
              <div className="Logo_FileName" title={imageFileName}>
                {imageFileName}
              </div>
              <div className="fileDownload">
                {fromForm === 'templatesetup' ? (
                  <Button
                    dataTestId="btn_Download"
                    Field={{
                      fieldValue: 'Download',
                      fieldLabel: 'Download',
                      startIcon: <DownloadIcon />,
                      // variant: 'secondary',
                      disabled: !disableDownload || false,
                    }}
                    className="btnDownload"
                    onClickHandler={downloadHandler}
                  ></Button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {previewViewer && filesCount > 1 && isMultiFileErrorShow ? (
        <span className="OrgLogo_ErrorMessage">{multiFileErrorMessage}</span>
      ) : null}
    </div>
  )
}

export default DropZoneNew
